import React from 'react'

const TopTab = ({ activeTab, setActiveTab, orderList }) => {
    const tabs = [
        { key: "all", label: "All" },
        { key: "new", label: "New" },
        { key: "delivered", label: "Delivered" },
        { key: "in-transit", label: "In Transit" },
        { key: "pickedUp", label: "Picked Up" },
        { key: "out-for-delivery", label: "Out for Delivery" },
    ]
    return (
        <div className='mt-3 mb-6 px-1 py-1'>
            <div className='overflow-x-auto'>
                <div className='inline-flex min-w-full items-center gap-5'>
                    {tabs.map((tab) => {
                        const isActive = activeTab === tab.key
                        return (
                            <button
                                key={tab.key}
                                type="button"
                                onClick={() => setActiveTab(tab.key)}
                                className={`rounded-full px-6 py-3 text-[1rem] font-[GilroyMedium] whitespace-nowrap transition-all duration-200 ${
                                    isActive
                                        ? "bg-[linear-gradient(135deg,_rgba(255,111,47,0.16),_rgba(255,151,110,0.08))] text-[#f97316] shadow-[inset_0_0_0_1px_rgba(251,146,60,0.2)]"
                                        : "text-slate-900 hover:text-[#f97316]"
                                }`}
                            >
                                <span>{tab.label}</span>
                            </button>
                        )
                    })}
                </div>
            </div>
        </div>
    )
}

export default TopTab
